webpackJsonp([111353116233215],{

/***/ 769:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.coordinatorsButtonStyle = exports.coordinatorsButtonSectionStyle = exports.roleSectionStyle = exports.subTitleStyle = exports.titleStyle = exports.cardSectionStyle = exports.contentSectionStyle = exports.innerWrapperStyle = exports.textStyle = exports.smallQuadrantsWrapperStyle = exports.quadrantsWrapperStyle = exports.quadrantsStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css, _css2, _divFirstChild, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var quadrantsStyle = /*#__PURE__*/exports.quadrantsStyle = (0, _emotion.css)((_css = {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'stretch',
		alignContent: 'stretch',
		position: 'relative',
		'& > *': {
			width: '50%',
			maxWidth: '458px',
			'& img': {
				display: 'block',
				marginBottom: '20px'
			},
			'& h1': (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
				marginBottom: '26px'
			})),
			'& p': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
				marginBottom: '40px'
			}))
		}
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'block',
		'& > section': {
			padding: '28px',
			width: '100%',
			maxWidth: 'initial'
		},
		'&:after': {
			display: 'none'
		}
	}, _css));
	
	var quadrantsWrapperStyle = exports.quadrantsWrapperStyle = (0, _emotion.cx)(quadrantsStyle, /*#__PURE__*/(0, _emotion.css)((_css2 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '70px auto'
	}, _css2['@media (min-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		'& section:first-child': {
			marginRight: '15px',
			width: 'calc(50% - 15px)'
		},
		'& section:last-child': {
			marginLeft: '15px',
			width: 'calc(50% - 15px)'
		}
	}, _css2['@media (min-width: ' + _globalStyles.desktopMaxWidthBreakpoint + 'px)'] = {
		'& section': {
			margin: '0 !important',
			width: '50% !important'
		}
	}, _css2)));
	
	var smallQuadrantsWrapperStyle = exports.smallQuadrantsWrapperStyle = (0, _emotion.cx)(quadrantsStyle, /*#__PURE__*/(0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		'& img': {
			height: '27px'
		},
		'& h1': {
			fontSize: '18px',
			lineHeight: '18px'
		}
	}));
	
	var textStyle = exports.textStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		'& p': {
			maxWidth: '800px'
		}
	}));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px'
	});
	
	var contentSectionStyle = exports.contentSectionStyle = _globalStyles.contentSection;
	
	var cardSectionStyle = exports.cardSectionStyle = function cardSectionStyle(margin) {
		return (0, _emotion.cx)((0, _globalStyles.cardSection)(margin), /*#__PURE__*/(0, _emotion.css)({
			'&#latest-updates': {
				'& header': {
					'& h1, & a': {
						color: '#fff'
					}
				}
			},
			'&#communication': {
				'& header': {
					'& h1': {
						color: _globalStyles.darkGrey
					},
					'& a': {
						color: _globalStyles.pink
					}
				}
			}
		}));
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '31px'
	}));
	
	var subTitleStyle = exports.subTitleStyle = _globalStyles.headingMedium;
	
	var roleSectionStyle = /*#__PURE__*/exports.roleSectionStyle = (0, _emotion.css)((_css3 = {
		display: 'flex',
		justifyContent: 'space-between',
		'& > div:first-child': (_divFirstChild = {
			marginRight: '94px'
		}, _divFirstChild['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
			marginRight: '44px'
		}, _divFirstChild['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
			marginRight: '0'
		}, _divFirstChild),
		'& [data-component=Card]': {
			width: '276px',
			height: '180px',
			flexShrink: '0'
		}
	
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		flexDirection: 'column',
		justifyContent: 'flex-start'
	}, _css3));
	
	var coordinatorsButtonSectionStyle = /*#__PURE__*/exports.coordinatorsButtonSectionStyle = (0, _emotion.css)({
		margin: '40px 0'
	});
	
	var coordinatorsButtonStyle = /*#__PURE__*/exports.coordinatorsButtonStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo900, {
		background: _globalStyles.pink,
		border: 'none',
		color: '#fff',
		fontSize: '18px',
		lineHeight: '15px',
		letterSpacing: '0.5',
		borderRadius: '4px',
		textTransform: 'uppercase',
		textDecoration: 'none',
		padding: '15px 17px 11px 17px'
	}));

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _navManager = __webpack_require__(22);
	
	var _arrowLink = __webpack_require__(52);
	
	var _cards = __webpack_require__(17);
	
	var _link = __webpack_require__(9);
	
	var _pageHeader = __webpack_require__(19);
	
	var _policyCard = __webpack_require__(216);
	
	var _headerNswOrange = __webpack_require__(769);
	
	var _headerNswOrange2 = _interopRequireDefault(_headerNswOrange);
	
	var _policyAndServiceDevelopment = __webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolicyServiceDevelopmentPage = function (_React$PureComponent) {
		_inherits(PolicyServiceDevelopmentPage, _React$PureComponent);
	
		function PolicyServiceDevelopmentPage() {
			_classCallCheck(this, PolicyServiceDevelopmentPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		PolicyServiceDevelopmentPage.prototype.render = function render() {
			var _props$data = this.props.data,
			    nswPolicies = _props$data.nswPolicies,
			    steeringCommitteePolicies = _props$data.steeringCommitteePolicies;
			var node = this.props.data.page.edges[0].node;
	
	
			return _react2.default.createElement(
				'div',
				{ className: _policyAndServiceDevelopment.wrapperStyle },
				_react2.default.createElement(_reactHelmet.Helmet, { title: node.main_heading }),
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: node.main_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: node.main_heading }),
					_react2.default.createElement('meta', { name: 'description', content: '' }),
					_react2.default.createElement('meta', { property: 'og:description', content: '' })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: '#F26C22',
					titleText: node.main_heading,
					icon: _headerNswOrange2.default,
					titleTextColor: '#fff'
				}),
				_react2.default.createElement(
					'section',
					{ className: (0, _policyAndServiceDevelopment.contentSectionStyle)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _policyAndServiceDevelopment.titleStyle },
								node.heading
							)
						),
						_react2.default.createElement('div', { className: _policyAndServiceDevelopment.textStyle, dangerouslySetInnerHTML: { __html: node.body } }),
						_react2.default.createElement(
							'section',
							{ className: (0, _policyAndServiceDevelopment.cardSectionStyle)() },
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 4 },
								node.main_attachments.map(function (attachment, index) {
									return _react2.default.createElement(_policyCard.PolicyCard, { key: index, href: attachment.file, title: attachment.title });
								})
							)
						),
						_react2.default.createElement('div', {
							className: _policyAndServiceDevelopment.textStyle,
							dangerouslySetInnerHTML: { __html: '<p>' + node.additional_body + '</p>' }
						})
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _policyAndServiceDevelopment.contentSectionStyle)() },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _policyAndServiceDevelopment.titleStyle },
								node.coordinators_heading
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _policyAndServiceDevelopment.roleSectionStyle },
							_react2.default.createElement('div', {
								className: _policyAndServiceDevelopment.textStyle,
								dangerouslySetInnerHTML: { __html: node.coordinators_body }
							}),
							_react2.default.createElement(_policyCard.PolicyCard, {
								href: node.coordinators_attachment.file,
								title: node.coordinators_attachment.title
							})
						),
						_react2.default.createElement(
							'div',
							{ className: _policyAndServiceDevelopment.coordinatorsButtonSectionStyle },
							_react2.default.createElement(
								_link.Link,
								{ to: node.coordinators_button_url, className: _policyAndServiceDevelopment.coordinatorsButtonStyle },
								node.coordinators_button_text
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _policyAndServiceDevelopment.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.quadrantsWrapperStyle },
						_react2.default.createElement(
							'section',
							null,
							_react2.default.createElement(
								'h1',
								null,
								node.left_heading
							),
							_react2.default.createElement('div', { className: _policyAndServiceDevelopment.textStyle, dangerouslySetInnerHTML: { __html: node.left_body } }),
							node.left_link_url && _react2.default.createElement(
								_arrowLink.ArrowLink,
								{ to: node.left_link_url },
								node.left_link_text
							)
						),
						_react2.default.createElement(
							'section',
							null,
							_react2.default.createElement(
								'h1',
								null,
								node.right_heading
							),
							_react2.default.createElement('div', { className: _policyAndServiceDevelopment.textStyle, dangerouslySetInnerHTML: { __html: node.right_body } }),
							node.right_link_url && _react2.default.createElement(
								_arrowLink.ArrowLink,
								{ to: node.right_link_url },
								node.right_link_text
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _policyAndServiceDevelopment.contentSectionStyle)('#505E64') },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: (0, _policyAndServiceDevelopment.cardSectionStyle)(), id: 'latest-updates' },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _policyAndServiceDevelopment.subTitleStyle },
									'Latest updates on service plan'
								),
								_react2.default.createElement(
									_link.Link,
									{ to: '/policy-and-service-development/updates-on-service-plan-in-nsw' },
									'View All Updates'
								)
							),
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 4 },
								nswPolicies.edges.map(function (_ref) {
									var node = _ref.node;
									return _react2.default.createElement(_policyCard.PolicyCard, {
										key: node.id,
										href: node.attachments[0].file,
										title: node.title,
										date: node.date
									});
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _policyAndServiceDevelopment.contentSectionStyle)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _policyAndServiceDevelopment.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: (0, _policyAndServiceDevelopment.cardSectionStyle)(), id: 'communication' },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _policyAndServiceDevelopment.subTitleStyle },
									'Communication from the State Wide Steering Committee'
								),
								_react2.default.createElement(
									_link.Link,
									{ to: '/policy-and-service-development/steering-committee' },
									'View All'
								)
							),
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 4 },
								steeringCommitteePolicies.edges.map(function (_ref2) {
									var node = _ref2.node;
									return _react2.default.createElement(_policyCard.PolicyCard, {
										key: node.id,
										href: node.attachments[0].file,
										title: node.title,
										date: node.date
									});
								})
							)
						)
					)
				)
			);
		};
	
		return PolicyServiceDevelopmentPage;
	}(_react2.default.PureComponent);
	
	PolicyServiceDevelopmentPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						main_heading: _propTypes2.default.string.isRequired,
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						main_attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							title: _propTypes2.default.string.isRequired,
							file: _propTypes2.default.string.isRequired
						})).isRequired,
						additional_body: _propTypes2.default.string.isRequired,
						coordinators_heading: _propTypes2.default.string.isRequired,
						coordinators_body: _propTypes2.default.string.isRequired,
						coordinators_attachment: _propTypes2.default.shape({
							title: _propTypes2.default.string.isRequired,
							file: _propTypes2.default.string.isRequired
						}),
						left_heading: _propTypes2.default.string.isRequired,
						left_body: _propTypes2.default.string.isRequired,
						left_link_text: _propTypes2.default.string.isRequired,
						left_link_url: _propTypes2.default.string.isRequired,
						right_heading: _propTypes2.default.string.isRequired,
						right_body: _propTypes2.default.string.isRequired,
						right_link_text: _propTypes2.default.string.isRequired,
						right_link_url: _propTypes2.default.string.isRequired
					})
				}))
			}),
	
			nswPolicies: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						id: _propTypes2.default.string,
						title: _propTypes2.default.string,
						type: _propTypes2.default.string,
						date: _propTypes2.default.string
					}).isRequired
				}).isRequired)
			}).isRequired,
	
			steeringCommitteePolicies: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						id: _propTypes2.default.string,
						title: _propTypes2.default.string,
						type: _propTypes2.default.string,
						date: _propTypes2.default.string
					}).isRequired
				}).isRequired)
			}).isRequired
		})
	};
	exports.default = PolicyServiceDevelopmentPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-policy-and-service-development-nsw-index-js-04de2f7363c9ab6973ef.js